import { useRef, useState } from "react";
import { toast } from "sonner";
import { Mic, MicOff } from "lucide-react";
import { useLang } from "../../lib/i18n";

// Voice provider: "browser" = free device dictation. An "ai" provider (server transcription) can be added later here.
export const VOICE_PROVIDER = "browser";
const SR = typeof window !== "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition);

export function VoiceInput({ onText, testid = "voice-input" }) {
  const { t, lang } = useLang();
  const [on, setOn] = useState(false);
  const rec = useRef(null);
  if (VOICE_PROVIDER !== "browser" || !SR) return null;
  const toggle = () => {
    if (on) { rec.current?.stop(); return; }
    const r = new SR();
    r.lang = lang === "es" ? "es-US" : "en-US";
    r.interimResults = false;
    r.continuous = true;
    r.onresult = (e) => onText(Array.from(e.results).slice(e.resultIndex).map((x) => x[0].transcript).join(" "));
    r.onerror = (e) => e.error !== "aborted" && toast.error(t("Microphone not available", "Micrófono no disponible"));
    r.onend = () => setOn(false);
    rec.current = r;
    r.start();
    setOn(true);
  };
  return (
    <button type="button" onClick={toggle} className={`w-14 h-14 shrink-0 ${on ? "btn-danger animate-pulse" : "btn-outline"}`} aria-label={t("Speak", "Hablar")} data-testid={testid}>
      {on ? <MicOff className="w-5 h-5" /> : <Mic className="w-5 h-5" />}
    </button>
  );
}
